// extracted by mini-css-extract-plugin
export default {"login-main":"Login_login-main__KcZpS","form":"Login_form__5XuQf"};